import { DailyForecastSummaryWidget } from './dailyForecastSummaryWidget';

const props = [];

export const DailyForecastSummaryWidgetDirective = reactDirective => reactDirective(DailyForecastSummaryWidget, props);
DailyForecastSummaryWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('dailyForecastSummaryWidget', DailyForecastSummaryWidgetDirective);
